import React from 'react';
import { connect } from 'react-redux';
import TransactionRow from '../AnalyticsPage/TransactionRow';

const mapStateToProps = (state) => {
  let myAccount = state.account.currentAccount;

  if (typeof myAccount === 'string') {
    myAccount = myAccount.toLowerCase();
  }

  return {
    transactions: state.transactions,
    myAccount: myAccount
  };
};

const connectedMyTransactions = ({transactions, myAccount}) => (
  <div className="c-component c-transactions">
    <h2>My Transactions</h2>
    <ul className="c-transactions__list">
      {transactions
        .filter((a) => a.args.from === myAccount || a.args.to === myAccount)
        .reverse()
        .slice(0, 10)
        .map((transactionEvent) => (
          <li key={transactionEvent.transactionHash} className="c-transactions__list-item">
            <TransactionRow transaction={transactionEvent}/>
          </li>
        ))}
    </ul>
  </div>
);

const MyTransactions = connect(mapStateToProps)(connectedMyTransactions);

export default MyTransactions;



// WEBPACK FOOTER //
// ./src/components/HomePage/MyTransactions.js